import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import { Glyphicon } from 'react-bootstrap';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import { HOUSE_RULES_BASE_QUERY_KEY } from './HouseRules.utils';
import HouseRulesTable from './HouseRulesTable';
import useHouseRulesModal from './modals/useHouseRulesModal';

const HouseRules = () => {
  const { t } = useTranslation();
  const { openBulkCreateModal } = useHouseRulesModal();
  const amountOfHouseRulesQueries = useIsFetching({
    queryKey: [HOUSE_RULES_BASE_QUERY_KEY],
  });
  const isFetchingHouseRules = amountOfHouseRulesQueries > 0;

  return (
    <section data-testid="property-house-rules-section">
      <SectionHeader
        id="house-rules-header"
        title={t('pageProperty.feesTaxesAndPolicies.houseRules.title')}
        buttons={
          <PropertyEditActionWrapper tooltipId="house-rules-header-button-tooltip">
            <Button
              bsStyle="primary"
              data-testid="house-rules-header-button"
              disabled={isFetchingHouseRules}
              onClick={openBulkCreateModal}
            >
              <Glyphicon glyph="plus" />
              {t('pageProperty.feesTaxesAndPolicies.houseRules.add')}
            </Button>
          </PropertyEditActionWrapper>
        }
        tooltip={t('pageProperty.feesTaxesAndPolicies.houseRules.tooltip')}
      />

      <HouseRulesTable />
    </section>
  );
};

export default HouseRules;
